/* Two-column cascading category menu: hover/focus/click a category in the
   left (red) column to swap which item list shows in the right (white)
   column. Self-contained per instance, keyed by data-pml-cat/data-pml-panel. */
(function () {
  function init(container) {
    var buttons = container.querySelectorAll('.pml-cascade-menu__cat-btn');
    var panels = container.querySelectorAll('.pml-cascade-menu__panel');

    function activate(catIndex) {
      buttons.forEach(function (b) {
        var active = b.getAttribute('data-pml-cat') === catIndex;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-pml-panel') === catIndex);
      });
    }

    buttons.forEach(function (btn) {
      var catIndex = btn.getAttribute('data-pml-cat');
      btn.addEventListener('mouseenter', function () {
        activate(catIndex);
      });
      btn.addEventListener('focus', function () {
        activate(catIndex);
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        activate(catIndex);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.pml-cascade-menu').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();
